// Web fallback: Datadog native logger not available on web.
// We still mirror to console to aid debugging.
const logToConsole = (level: "debug" | "info" | "warn" | "error", message: string) => {
  switch (level) {
    case "error":
      // eslint-disable-next-line no-console
      console.error(message);
      break;
    case "warn":
      // eslint-disable-next-line no-console
      console.warn(message);
      break;
    case "info":
      // eslint-disable-next-line no-console
      console.info(message);
      break;
    case "debug":
    default:
      // eslint-disable-next-line no-console
      console.debug(message);
      break;
  }
};

export const ddLogs = {
  debug: (msg: string) => logToConsole("debug", msg),
  info: (msg: string) => logToConsole("info", msg),
  warn: (msg: string) => logToConsole("warn", msg),
  error: (msg: string) => logToConsole("error", msg),
};

